/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save(props) {
    const { attributes, setAttributes, blockProps, clientId, className } = props;
    const { submitText, customPrompt } = attributes;

    return (
        <div { ...blockProps }>
            <div class="momo-acg-ai-form-submit-bottom">
                <button id="momo-generate-output-from-form" data-value={submitText} data-prompt={customPrompt}>{submitText}</button>
            </div>
            <div class="momo-forms-result-block">
            </div>
        </div>

    );
}
